export default __webpack_public_path__ + "static/media/T54.372fc2f6.png";